import store from "../../store/store";
import {attemptToBuildFromCatalog, attributeSelectionsClear} from "../../store/product/productDataSlice";
import {setErrors} from "../../store/configuratorStateSlice";

import {createApi, fetchBaseQuery} from '@reduxjs/toolkit/query/react'

export const productApi = createApi({
    reducerPath: 'productApi',
    baseQuery: fetchBaseQuery({baseUrl: window.location.origin + '/api/v1/configurator/products/'}),
    endpoints: (builder) => ({
        getProduct: builder.query({
            query: (id) => `${id}`
        }),
        getProductByCatalogNumber: builder.query({
            query: (catalogNumber) => `lookup/${catalogNumber.trim()}`
        }),
        getProductElements: builder.query({
            query: (id) => `${id}/product_elements`
        }),
        getFamilyVersions: builder.query({
            query: () => `family_versions`

        }),
        generateShapeElements: builder.mutation({
            query: ({id, attribute_selections}) => ({
                url: `${id}/generate_shape_elements`,
                method: 'POST',
                body: {
                    product: {
                        attribute_selections
                    }
                }
            }),

        })
    })
})
export const {useGetProductQuery, useGetProductByCatalogNumberQuery, useGetProductElementsQuery, useGetFamilyVersionsQuery, useGenerateShapeElementsMutation} = productApi;

